import React from "react";
import { DesignsShow } from "./DesignsShow";
import { TopNav } from "./TopNav";

function DesignPage({ props }) {
  
  return (
    <>
      <div className="design--page--wrapper">
        <main className="design--main">
          <TopNav path={props.location.pathname} />
          <DesignsShow />
        </main>
      </div>
    </>
  );
}

export { DesignPage };
